import { i18n } from "@/config/i18n";

export default {
  name: "PuPrimeVietnamReward",
  data() {
    return {
      showCopyToast: false,
      guideModal: null, // { src, caption }
      rewards: [
        { icon: '🎁', name: 'Bộ ly chén thiên nga đúc lá vàng 24k', level: i18n.global.t('blog.puPrime.level1'), highlight: false },
        { icon: '📱', name: 'Samsung Galaxy S26',                    level: i18n.global.t('blog.puPrime.level2'), highlight: false },
        { icon: '📺', name: 'Smart TV Samsung Neo QLED 4K 75"',      level: i18n.global.t('blog.puPrime.level3'), highlight: false },
        { icon: '💻', name: 'Laptop Lenovo Legion Pro 7',            level: i18n.global.t('blog.puPrime.level4'), highlight: false },
        { icon: '⌚', name: 'Rolex Explorer 36 Oyster',              level: i18n.global.t('blog.puPrime.level5'), highlight: false },
        { icon: '🚘', name: 'VinFast Limo Xanh',                    level: i18n.global.t('blog.puPrime.level6'), highlight: false },
        { icon: '🚗', name: 'BMW X4 2026',                          level: i18n.global.t('blog.puPrime.level7'), highlight: true  },
      ],
      steps: [
        {
          title: i18n.global.t('blog.puPrime.step1Title'),
          desc:  i18n.global.t('blog.puPrime.step1Desc'),
        },
        {
          title: i18n.global.t('blog.puPrime.step2Title'),
          desc:  i18n.global.t('blog.puPrime.step2Desc'),
        },
        {
          title: i18n.global.t('blog.puPrime.step3Title'),
          desc:  i18n.global.t('blog.puPrime.step3Desc'),
        },
        {
          title: i18n.global.t('blog.puPrime.step4Title'),
          desc:  i18n.global.t('blog.puPrime.step4Desc'),
        },
      ],
      guides: {
        pu: {
          src: 'https://songhancapital.com/assets/image/open_puprice.jpg',
          caption: i18n.global.t('blog.puPrime.guidePuCaption'),
        },
        vantage: {
          src: 'https://songhancapital.com/assets/image/open_vantage.jpg',
          caption: i18n.global.t('blog.puPrime.guideVantageCaption'),
        },
      },
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    goToContact() {
      this.$router.push({ name: 'Contact' });
    },
    copyCode(code) {
      navigator.clipboard.writeText(code).catch(() => {});
      this.showCopyToast = true;
      setTimeout(() => { this.showCopyToast = false; }, 2000);
    },
    openGuide(broker) {
      this.guideModal = this.guides[broker] || null;
    },
    closeGuide() {
      this.guideModal = null;
    },
  },
};
